import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../Redux/NewHire/Action";
import Navbar from "../Navbar/Navbar";
import "./ChangePassword.css";
import Swal from "sweetalert2";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const loginId = localStorage.getItem("loginId");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);


  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    loginId: loginId || "",
  });

  const clearPasswordInputFields = () => {
    setPasswordData({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      loginId: loginId || "",
    });
  };


  const handleChange = (e) => {
    const { id, value } = e.target;

    setPasswordData((prevValues) => {
      const updatedValues = { ...prevValues, [id]: value };

      if (id === "newPassword" || id === "confirmPassword") {
        if (
          updatedValues.newPassword &&
          updatedValues.confirmPassword &&
          updatedValues.newPassword !== updatedValues.confirmPassword
        ) {
          setErrorMessage("New Password and Confirm Password did not match.");
          setIsSubmitDisabled(true);
        } else {
          setErrorMessage("");
          setIsSubmitDisabled(
            !updatedValues.oldPassword ||
            !updatedValues.newPassword ||
            !updatedValues.confirmPassword
          );
        }
      }
      return updatedValues;
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleSubmitPasswordChange = async (e) => {
    e.preventDefault();
    if (!passwordData.oldPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      Swal.fire("Error", "All fields are required!", "error");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(changePassword(passwordData))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            clearPasswordInputFields();
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  return (
    <div>
      <Navbar />
            <div className="main-content">
      <div className="container-fluid mt-4">
       <div className="row justify-content-center mt-4">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <form onSubmit={handleSubmitPasswordChange}>
                <div className="mb-3">
                  <label htmlFor="currentPassword" className="form-label">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="oldPassword"
                    placeholder="Enter current password"
                    value={passwordData.oldPassword || ''}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    placeholder="Enter new password"
                    value={passwordData.newPassword || ''}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    placeholder="Confirm new password"
                    value={passwordData.confirmPassword || ''}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary" disabled={isSubmitDisabled}>
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default ChangePassword;
